import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import AdminAssessmentTemplates from "../widgets/adminAssesmentTemplates";
import AdminCommunications from "../widgets/adminCommunications";
import AdminCommunicationTemplates from "../widgets/adminCommunicationTemplates";
import AdminPartners from "../widgets/adminPartners";
import AdminPatients from "../widgets/adminPatients";
import AdminPractices from "../widgets/adminPractices";
import AdminReports from "../widgets/adminReports";

const AdminPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Administration" />
      <PortalGridContent>
        <Grid item xs={12} sm={12} md={6}>
          <AdminReports />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminAssessmentTemplates />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminPatients />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminPartners />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminCommunications />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminCommunicationTemplates />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminPractices />
        </Grid>
        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  awsGroup: state.userSession.awsGroup,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminPortal));
